import "./App.css";
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Home from "./Pages/Home/Home";
import React, { useEffect, useState } from "react";
import NavBasic from "./Components/Navbar/NavBasic/NavBasic";
import FloatingButton from "./Components/FloatingButton/FloatingButton";
import Footer from "./Components/Footer/Footer";
import AdminLogin from "./Pages/AuthPages/AdminLogin/AdminLogin";
import AdminLayout from "./Pages/Admin/Layout/AdminLayout";
import NavBuilder from "./Pages/Admin/NavBuilder/NavBuilder";
import { getComponent, getCurrentWebsite, PreferedLanguage } from "./ComponentsMap";
import { createNavInstance } from "./Models/Nav";
import ServerUnavailable from "./Pages/Errors/ServerUnavailable/ServerUnavailable";
import { getCurrentTenant, setNavigateFunction } from "./Services/Axios/axiosInstance";
import FooterBuilder from "./Pages/Admin/FooterBuilder/FooterBuilder";
import LayoutBuilder from "./Pages/Admin/LayoutBuilder/LayoutBuilder";
import CTAPrimaryButton from "./Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton";
import CampaignsType from "./Pages/Admin/Donations/CampaignsType/CampaignsType";
import AddCampaignType from "./Pages/Admin/Donations/CampaignsType/Add/AddCampaignType";
import EditCampaignType from "./Pages/Admin/Donations/CampaignsType/Edit/EditCampaignsType";
import Campaigns from "./Pages/Admin/Donations/Campaigns/Campaigns";
import EditCampaign from "./Pages/Admin/Donations/Campaigns/Edit/EditCampaign";
import AddCampaign from "./Pages/Admin/Donations/Campaigns/Add/AddCampaign";
import Donors from "./Pages/Admin/Donations/Donors/Donors";
import DonorProfile from "./Pages/Admin/Donations/Donors/DonorProfile/DonorProfile";
import DonationsList from "./Pages/Admin/Donations/DonationsList";
import DonationCardBuilder from "./Pages/Admin/DonationCardBuilder/DonationCardBuilder";
import SliderBuilder from "./Pages/Admin/HomePageBuilder/SliderBuilder";
import CampaignsPage from "./Pages/Campaigns/Campaigns";
import SingleCampaign from "./Pages/Campaigns/SingleCampaign";
import Media from "./Pages/Admin/Media/Media";
import GalleryBuilder from "./Pages/Admin/HomePageBuilder/GalleryBuilder";
import HomeBuilder from "./Pages/Admin/HomePageBuilder/HomeBuilder";
import NotFound from "./Pages/NotFound/NotFound";
import SimpleNewsTicker from "./Components/NewsTickers/SimpleNewsTicker";
import NewsTickerBuilder from "./Pages/Admin/HomePageBuilder/NewsTickerBuilder";
import { createDonationCardInstance } from "./Models/DonationCard";
import DonationForm from "./Pages/DonationForm/DonationForm";
import SponsorsSlider from "./Components/SponsorsSlider/SponsorsSlider";
import SponsorsGrid from "./Components/SponsorsGrid/SponsorsGrid";
import SponsersBuilder from "./Pages/Admin/SponsersBuilder/SponsersBuilder";
import FloatingButtonBuilder from "./Pages/Admin/FloatingButtonBuilder/FloatingButtonBuilder";
import { createFloatingButtonInstance } from "./Models/FloatingButton";
import BJSpinner from "./Components/Loader/BJSpinner";
import PageBuilder from "./Pages/Admin/PageBuilder/PageBuilder";
import Pages from "./Pages/Admin/Pages/Pages";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import { AuthProvider } from "./contexts/AuthContext";
import DonorUserProfile from "./Pages/DonorProfile/DonorProfile";
import Membership from "./Pages/Membership/Membership";
import ContactUs from "./Pages/ContactUs/ContactUs";
import About from "./Pages/About/About";
import ConfirmEmail from "./Pages/Auth/ConfirmEmail";
import CallBack from "./Pages/CallBack/CallBack";
import HomeAdminPanel from "./Pages/Admin/Home/HomeAdminPanel";
import { ToastContainer } from "react-toastify";
import TranslateTest from "./Components/TranslateTest/TranslateTest";
import i18n from "./Services/i18n/i18n";
import AbwabAboutUs from "./Pages/About/AbwabAboutUs";
import PagePreview from "./Pages/PagePreview/PagePreview";
import SanadDonationForm from "./Pages/DonationForm/SanadDonationForm";
import TestPayPal from "./Components/Braintree/TestPayPal";
import SubscriptionPayment from "./Components/SubscriptionPayment/SubscriptionPayment";
import Settings from "./Pages/Admin/Settings/Settings";
import ForgotPassword from "./Pages/AuthPages/ForgotPassword/ForgotPassword";
import ResetPassword from "./Pages/AuthPages/ForgotPassword/ResetPassword";
import GeneralDonation from "./Pages/GeneralDonation/GeneralDonation";
import NavCenter from "./Components/Navbar/NavCenter/NavCenter";
import Search from "./Pages/Search/Search";
import { initAosLite, refreshAosLite } from "./Services/Animations/aosLite";
function App() {
  // tenant is initialized centrally in axios setup

  const navigate = useNavigate();
  const location = useLocation();

    useEffect(() => {
        initAosLite({ once: true });
    }, []);
  const [donationCardInstance, setDonationCardInstance] = useState(createDonationCardInstance());
  const [currentData, setCurrentData] = useState(donationCardInstance.getData());

  useEffect(() => {
      getCampaigns();
  }, []);

  useEffect(() => {
      window.scrollTo(0, 0);
  }, [location]);

	useEffect(() => {
		refreshAosLite();
	}, [location]);

  const getCampaigns = async () => {
      try {
          await donationCardInstance.load();
          setCurrentData(donationCardInstance.getData());
          donationCardInstance.renderStyles();
      } catch (error) {
          console.error(error);
      }
  };

  useEffect(() => {
      setNavigateFunction(navigate);
  }, [navigate]);

  const [navInstance, setNavInstance] = useState(createNavInstance());
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');

  useEffect(() => {
      const handleAuthChange = () => setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
      window.addEventListener('authChange', handleAuthChange);
      return () => window.removeEventListener('authChange', handleAuthChange);
  }, []);

  useEffect(() => {
      getData();
  }, []);

  const getData = async () => {
      try {
        setLoading(true)
          await navInstance.load(i18n.language);    
           
      } catch (error) {
          console.error(error);
      }
      finally{
        setLoading(false);         
      }
  };

  const getDirection = () => {
    return localStorage.getItem('selectedDirection');
  }


  return (
    <AuthProvider>
      
      <Routes>
        <Route
          path="/*"
          element={
            <div >
            <ToastContainer />
              {getComponent(navInstance.getType() , "")}
              <SimpleNewsTicker  />
              <BJSpinner isLoading={loading} text="Loading..." color="#2B7CD3" />
              <FloatingButton/>
              
              <Routes>
                <Route path="/" element={localStorage.getItem("HId")!=0?<PagePreview id={Number(localStorage.getItem("HId"))} isHomePage={true}/>:<Home/>} />
                {/* <Route path="/home" element={<Home />} /> */}
                <Route path="/campaigns" element={<CampaignsPage />} />
                <Route path="/campaigns/:name" element={<SingleCampaign />} />
                <Route path="/notfound" element={<NotFound />} />
                <Route path="/search" element={<Search />} />
                <Route path="/:slug" element={<PagePreview />} />
                <Route path="/testpaypal" element={<TestPayPal />} />
                <Route path="/donate/:name" element={isLoggedIn ? <DonationForm />: <Membership />} />
                <Route path="/general-donate" element={isLoggedIn ? <GeneralDonation />: <Membership />} />
                <Route path="/subscription/:method" element={<SubscriptionPayment />} />
                <Route path="/donor-profile" element={isLoggedIn ? <DonorUserProfile /> : <Membership />} />
                <Route path="/membership" element={isLoggedIn ? <DonorUserProfile /> : <Membership />} />
                <Route path="/contact" element={<ContactUs />} />
                {/* <Route path="/about" element={getCurrentWebsite() === "abwab" ? <AbwabAboutUs /> : <About />} /> */}
                <Route path="/confirmation" element={<ConfirmEmail />} />
                <Route path="/callback/:method" element={<CallBack />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/resetpassword" element={<ResetPassword />} />
              </Routes>
              <Footer direction={getDirection()} />
            </div>
          }
        />
        <Route path="/bj-login" element={<AdminLogin />} />
        <Route path="/ServerUnavailable" element={<ServerUnavailable />} />
        
        {/* Wrap admin routes with PrivateRoute */}
        <Route element={<PrivateRoute />}>
          <Route
            path="/bj-admin/*"
            element={
              <AdminLayout>
                <Routes>
                  <Route path="/" element={<HomeAdminPanel/>}/>
                  <Route path="/home" element={<HomeAdminPanel/>}/>
                  <Route path="/navbuilder" element={<NavBuilder />} />
                  <Route path="/layoutBuilder" element={<LayoutBuilder />} />
                  <Route path="/FooterBuilder" element={<FooterBuilder />} />
                  <Route path="/SponsersBuilder" element={<SponsersBuilder/>} />
                  <Route path="/FloatingButtonBuilder" element={<FloatingButtonBuilder/>} />
                  <Route path="/Donations/campaignsType" element={<CampaignsType/>} />
                  <Route path="/Donations/campaignsType/add" element={<AddCampaignType/>} />
                  <Route path="/Donations/campaignsType/edit/:id" element={<EditCampaignType/>} />
                  <Route path="/Donations/campaigns" element={<Campaigns/>} />
                  <Route path="/Donations/campaigns/edit/:id" element={<EditCampaign/>} />
                  <Route path="/Donations/campaigns/add" element={<AddCampaign/>} />
                  <Route path="/Donations/donors" element={<Donors/>} />
                  <Route path="/Donations/donors/profile/:email" element={<DonorProfile/>} />
                  <Route path="/Donations" element={<DonationsList/>} />
                  <Route path="/Donations/style" element={<DonationCardBuilder/>} />
                  <Route path="/pages/home" element={<HomeBuilder/>} />
                  <Route path="/pages/home/slider" element={<SliderBuilder/>} />
                  <Route path="/pages/home/slider/:id" element={<SliderBuilder/>} />
                  <Route path="/pages/home/gallery" element={<GalleryBuilder/>} />
                  <Route path="/pages/home/news-ticker" element={<NewsTickerBuilder/>} />
                  <Route path="/media" element={<Media/>} />
                  <Route path="/pages/page-builder" element={<PageBuilder/>} />
                  <Route path="/pages/page-builder/:id" element={<PageBuilder/>} />
                  <Route path="/pages" element={<Pages/>} />
                  <Route path="/settings" element={<Settings/>} />
                </Routes>
              </AdminLayout>
            }
          />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;